function f(t, e) {
  const n = (r) => Object.keys(t).reduce((s, a) => ({
    ...s,
    [a]: t[a](r)
  }), {});
  return arguments.length === 2 && e ? n(e) : (r) => n(r);
}
export {
  f as t
};
//# sourceMappingURL=transformObject-BRKclT1m.mjs.map
